import { ref } from 'vue'

// Set true when index navigation starts (at click time) so the main nav
// fades out in sync with the archive text. Cleared in Index.vue onActivated.
export const navFading = ref(false)
